import { useEffect } from "react";

const metaName = "robots";
const metaContent = "noindex, nofollow";

/** BR-42 — discourage indexing of app auth/onboarding routes. */
export default function AuthNoIndex() {
    useEffect(() => {
        let meta = document.querySelector(`meta[name="${metaName}"]`) as HTMLMetaElement | null;
        const created = !meta;
        if (!meta) {
            meta = document.createElement("meta");
            meta.name = metaName;
            document.head.appendChild(meta);
        }
        const previous = meta.content;
        meta.content = metaContent;
        return () => {
            if (created) {
                meta?.remove();
            } else if (meta) {
                meta.content = previous;
            }
        };
    }, []);

    return null;
}
